<template>
  <!-- 客户支持 -->
  <div class="joinUsNav">
    <!-- 头部 -->
    <headerNav
      activeIndex="customer"
      @getUrl="getUrl"
      @getContent="getContent"
      @getJoinObj="getJoinObj"
    ></headerNav>
    <!-- 轮播图 -->
    <bannerNav
      :carousel="info.carousel"
      :Mcarousel="info.Mcarousel"
    ></bannerNav>
    <div class="pc">
      <div style="padding: 0 72px 72px" id="mainNav">
        <div class="maxWidth mainNav" ref="mainNav" id="mainNav1">
          <div class="mainIndex">
            <ul id="aboutUsIndex" style="position: relative">
              <div
                :style="`position:absolute;top:${top}px;right:55px;width:74px;height:2px;background:#3f6b33;transition: all 0.5s;`"
              ></div>
              <li class="title Regular">联系我们</li>
              <li class="index">
                <span
                  :class="navIndex === 1 ? 'selectBtn' : 'clickBtn2'"
                  @click="goback(1)"
                  >联系方式</span
                >
              </li>
              <li class="index">
                <span
                  class=""
                  :class="navIndex === 2 ? 'selectBtn' : 'clickBtn2'"
                  @click="goback(2)"
                  >在线留言</span
                >
              </li>
              <li class="index">
                <span
                  class=""
                  :class="navIndex === 3 ? 'selectBtn' : 'clickBtn2'"
                  >人才招聘</span
                >
              </li>
            </ul>
          </div>
          <!-- 右侧内容 -->
          <div
            class="mainContent"
            style="border-left: 1px solid #719468; padding-left: 55px"
          >
            <div
              style="
                border-bottom: 1px solid #719468;
                padding: 14px 0;
                line-height: 23px;
                display: flex;
              "
            >
              <div style="font-size: 23px" class="clickBtn1" @click="goHome">
                首页
              </div>
              <div style="font-size: 18px; margin: 0 12px">-</div>
              <div style="font-size: 18px">联系我们</div>
              <div style="font-size: 18px; margin: 0 12px">-</div>
              <div style="font-size: 18px" @click="type = 1">
                人才招聘
              </div>
            </div>
            <div
              style="padding: 0px 20px"
              :style="type === 2 ? `margin-top:20px;` : ''"
            >
              <div
                style="
                  background: #e9e8e8;
                  padding: 10px 30px;
                  width: 55%;
                  border-radius: 10px;
                  margin: 50px auto 10px;
                  position: relative;
                "
              >
                <div
                  style="
                    position: absolute;
                    top: 0;
                    transform: translate3d(-50%, -50%, 0);
                    left: 50%;
                    text-align: center;
                  "
                >
                  <img src="@/assets/zpgw.png" style="width: 300px" alt="" />
                </div>
                <div
                  style="width: 100%; margin: 28px 0 30px"
                  class="ql-editor"
                  v-html="content"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div style="padding: 0 0.2rem">
        <div
          style="
            margin-top: 0.3rem;
            text-align: center;
            position: relative;
            background: #e9e8e8;
            border-radius: 10px;
          "
        >
          <div
            style="
              position: absolute;
              top: 0;
              transform: translate3d(-50%, -50%, 0);
              left: 50%;
              text-align: center;
            "
          >
            <img src="@/assets/zpgw.png" style="width: 50vw" alt="" />
          </div>
          <div
            style="
              width: 100%;
              margin: 0.3rem 0 0.2rem;
              padding: 0.3rem 0.2rem;
              font-size: 0.16rem;
            "
            class="ql-editor"
            v-html="mobContent"
          ></div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <RightBar></RightBar>
    <footerNav></footerNav>
  </div>
</template>

<script>
import headerNav from "@/components/headerNav/index";
import bannerNav from "@/components/banner/index";
import footerNav from "@/components/footerNav/index";
import { getConfByKey, AddOnlineMessage } from "@/api/common";
import BmGeolocation from "vue-baidu-map/components/controls/Geolocation.vue"; //定位
import BmMapType from "vue-baidu-map/components/controls/MapType.vue"; //地图类型
import BmCityList from "vue-baidu-map/components/controls/CityList.vue"; //城市列表
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue"; //标记点
import verification from "@/components/verification";
import $ from "jquery";
export default {
  name: "customerSupportNav",
  components: {
    headerNav,
    footerNav,
    bannerNav,
    BmGeolocation,
    BmMapType,
    BmCityList,
    verification,
    BmMarker,
  },
  data() {
    return {
      info: {
        carousel: [],
        Mcarousel: "",
      }, //轮播图
      show: true,
      mobile: false,
      navIndex: 3,
      childrenListName: "",
      brandProfileNavShow: false,
      top: 100,
      numShow: false,
      currentPage1: 1,
      type: 1,
      qrcode: "", //微信公众号二维码
      customerQrcode: "", //微信公众号二维码
      center: { lng: 113.35344, lat: 23.01368 },
      verificationkey1: false,
      form: {
        name: "",
        phone: "",
        email: "",
        address: "",
        remark: "",
      },
      content: "", //招聘信息
      mobContent: "", //手机端显示招聘内容
      address: "",
      addressList: [],
      phone: "",
      path: "",
      customerQrcode: "",
      qrcode: "",
      childrenList: [], //子项列表
    };
  },
  mounted() {
    this.mobile = this.isMobile();
    if (this.isMobile() === true) {
      this.postMessage(
        "御方汇植物化妆品原料【联系方式官网】",
        "客户支持",
        window.location.href,
      );
    }
  },
  methods: {
    // 获取地址#后面的内容
    GetRequest() {
      var str = location.href;
      var num = str.indexOf("#");
      if (num !== -1) {
        str = str.substr(num);
        return str;
      } else {
        return null;
      }
    },
    getContent(content){
      console.log("content",content)
    },
    // 获取手机招聘信息/
    getJoinObj(obj) {
      var url = this.getUrlPrefix(obj.images)
      var mUrl = this.getUrlPrefix(obj.mobileImages)
      this.info = {
        carousel: [url],
        Mcarousel: [mUrl],
      };
      this.content = obj.content;
      this.mobContent = obj.content;
      this.top = 96 + 57 * 2;
    },

    goNav(name) {
      var a = document.getElementById("mainNav").offsetTop;
      $("body,html").animate({ scrollTop: a - 120 }, 200);
      if (this.navIndex === name) {
        return;
      }
      this.navIndex = name;
      this.childrenListName = this.childrenList[name].menuName;
      this.type = 1;
      this.top = 96 + 57 * name;
    },
    goNav1(name) {
      var top = 560;
      if (this.isMobile() === true) {
        name = name + "M";
        top = 0;
      }

      var a = document.getElementById(name).offsetTop;
      $("body,html").animate({ scrollTop: a + top }, 200);
    },
    goback(type){
      
      var path = `/customer#nav${type}`
        this.$router.push({ path })
    },
    getUrl(val) {
      var name = val.replace("#", "");
      this.$nextTick(() => {
        this.goNav1(name);
      });
    },
    goHome() {
      this.$router.push({ name: "home" });
    },
  },

  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
  },
};
</script>

<style lang="scss">
.joinUsNav {
  .maxWidth {
    width: 1229px;
    margin: 0 auto;
  }
  .mainIndex {
    width: 217px;
  }
  .mainContent {
    flex: 1;
  }
  .mainNav {
    position: relative;
    margin-top: 98px;
    display: flex;
  }
  .brandProfileNav {
    position: relative;
  }
  .mainIndex {
    text-align: right;
    ul {
      padding: 8px 55px 8px 0;
    }
    .title {
      color: #1b1b1b;
      font-size: 27px;
      line-height: 27px;
      margin-bottom: 32px;
    }
    .index {
      color: #707070;
      font-size: 18px;
      line-height: 27px;
      margin-bottom: 30px;
    }
    .index:last-child {
      margin-bottom: 0;
    }
  }
  .clickBtn2 {
    cursor: pointer;
  }
  .selectBtn {
    color: #3f6b33;
    cursor: pointer;
    position: relative;
  }
  .selectBtn1::after {
    content: "";
    width: 100%;
    height: 2px;
    background: #3f6b33;
    position: absolute;
    bottom: -10px;
    left: 0;
    transition: all 0.5s ease 0s;
  }
  .mobile {
    .el-form-item__label {
      line-height: 26px;
    }
  }
  .ql-editor {
    font-family: "微软雅黑", Microsoft YaHei, Avenir, Helvetica, Arial,
      sans-serif;
  }

  .ql-editor img {
    width: 70%;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/joinUs/index.vue